import React from 'react';
import Svg, {
  Defs, G, Path, Rect, Circle,
} from 'react-native-svg';

const NoFloorsImage = () => <Svg width='202' height='121' viewBox='0 0 202 121' fill='none'>
  <Rect x='24' width='154' height='120' rx='8' fill='#E6EEF7' />
  <G filter='url(#filter0_d_232_11633)'>
    <Rect x='12' y='8' width='182' height='48' rx='4' fill='white' />
    <Circle cx='36' cy='32' r='16' fill='#548FC8' />
    <Path d='M39.3332 25.3333V28.6666H35.9999V31.9999H32.6666V35.3332H29.3333V38.6666H42.6666V25.3333H39.3332Z' fill='white' />
    <Rect x='60' y='23.5' width='36' height='8' rx='2' fill='#B0CBE6' />
    <Rect x='60' y='36.5' width='36' height='4' rx='2' fill='#B0CBE6' />
    <Rect x='126' y='28' width='6' height='8' rx='2' fill='#B0CBE6' />
    <Rect x='149' y='28' width='6' height='8' rx='2' fill='#B0CBE6' />
    <Rect x='172' y='28' width='6' height='8' rx='2' fill='#B0CBE6' />
    <Rect x='12.5' y='8.5' width='181' height='47' rx='3.5' stroke='#F4F7FB' />
  </G>
  <G filter='url(#filter1_d_232_11633)'>
    <Rect x='8' y='64' width='182' height='48' rx='4' fill='white' />
    <Circle cx='32' cy='88' r='16' fill='#548FC8' />
    <Path d='M35.3332 81.3333V84.6666H31.9999V87.9999H28.6666V91.3332H25.3333V94.6666H38.6666V81.3333H35.3332Z' fill='white' />
    <Rect x='56' y='79.5' width='36' height='8' rx='2' fill='#B0CBE6' />
    <Rect x='56' y='92.5' width='36' height='4' rx='2' fill='#B0CBE6' />
    <Rect x='122' y='84' width='6' height='8' rx='2' fill='#B0CBE6' />
    <Rect x='145' y='84' width='6' height='8' rx='2' fill='#B0CBE6' />
    <Rect x='168' y='84' width='6' height='8' rx='2' fill='#B0CBE6' />
    <Rect x='8.5' y='64.5' width='181' height='47' rx='3.5' stroke='#F4F7FB' />
  </G>
  <Defs>
    <filter id='filter0_d_232_11633' x='5' y='3' width='196' height='62' filterUnits='userSpaceOnUse' colorInterpolationFilters='sRGB'>
      <feFlood floodOpacity='0' result='BackgroundImageFix' />
      <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
      <feMorphology radius='1' operator='dilate' in='SourceAlpha' result='effect1_dropShadow_232_11633' />
      <feOffset dy='2' />
      <feGaussianBlur stdDeviation='3' />
      <feColorMatrix type='matrix' values='0 0 0 0 0.690196 0 0 0 0 0.796078 0 0 0 0 0.901961 0 0 0 0.08 0' />
      <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_232_11633' />
      <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_232_11633' result='shape' />
    </filter>
    <filter id='filter1_d_232_11633' x='1' y='59' width='196' height='62' filterUnits='userSpaceOnUse' colorInterpolationFilters='sRGB'>
      <feFlood floodOpacity='0' result='BackgroundImageFix' />
      <feColorMatrix in='SourceAlpha' type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
      <feMorphology radius='1' operator='dilate' in='SourceAlpha' result='effect1_dropShadow_232_11633' />
      <feOffset dy='2' />
      <feGaussianBlur stdDeviation='3' />
      <feColorMatrix type='matrix' values='0 0 0 0 0.690196 0 0 0 0 0.796078 0 0 0 0 0.901961 0 0 0 0.08 0' />
      <feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_232_11633' />
      <feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_232_11633' result='shape' />
    </filter>
  </Defs>
</Svg>;

export default NoFloorsImage;
